export default "__VITE_ASSET__JX3AnxNG__"